import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TWCButton } from '@components';

import { assets } from '@assets';
import { Theme } from '@constants';
import { useContextReference } from '@hooks';

import { SIZES } from './constants';
import { styles } from './styles';

import { tPath } from '../constants';

type FocusType = number | null | undefined;

type ChangeMapButtonProps = {
  accessibilityHint: string;
  accessibilityLabel: string;
  testID: string;
  onPress: () => void;
  nextFocusDown: FocusType;
  nextFocusLeft: FocusType;
  nextFocusRight: FocusType;
  nextFocusUp: FocusType;
};

export const ChangeMapButton: FC<ChangeMapButtonProps> = ({
  accessibilityHint,
  accessibilityLabel,
  testID,
  onPress,
  nextFocusDown,
  nextFocusLeft,
  nextFocusRight,
  nextFocusUp,
}) => {
  const { t } = useTranslation();

  return (
    <TWCButton
      accessibilityHint={accessibilityHint}
      accessibilityLabel={accessibilityLabel}
      icon={assets.changeMapFilter}
      iconFocused={assets.changeMapFilterFocused}
      nativeID={testID}
      nextFocusDown={nextFocusDown}
      nextFocusLeft={nextFocusLeft}
      nextFocusRight={nextFocusRight}
      nextFocusUp={nextFocusUp}
      ref={useContextReference(testID)}
      style={styles.changeMapButton}
      styleFocused={Theme.styles.border}
      testID={testID}
      title={t(`${tPath}changeMapButton.title`)}
      underlayColor={Theme.whisperWhite}
      width={SIZES.changeMapButtonWidth}
      onPress={onPress}
    />
  );
};
